let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("lgdNv")).then(() => parcelRequire('e9ZyH'));